"use client";

import { useEditMode } from "@/contexts/EditModeContext";
import { Pencil, X } from "lucide-react";
import { m, AnimatePresence } from "framer-motion";
import { cn } from "@/lib/shared/utils";

export default function EditModeToggle() {
  const { isEditing, isAdmin, toggleEditMode } = useEditMode();

  if (!isAdmin) return null;

  return (
    <div className="fixed right-6 bottom-6 z-[100] flex flex-col items-end gap-2">
      <AnimatePresence>
        {isEditing && (
          <m.div
            initial={{ opacity: 0, y: 10, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 10, scale: 0.95 }}
            transition={{ duration: 0.2 }}
            className="bg-background border-foreground max-w-[260px] border-2 p-3 shadow-[4px_4px_0px_0px_var(--foreground)]"
          >
            <p className="mb-1 font-mono text-[10px] font-bold tracking-wider uppercase">
              Edit Mode Active
            </p>
            <p className="text-muted-foreground font-mono text-[10px] leading-tight">
              Click any text to edit it. Use section toggles to hide/show elements. Click on section
              indicators to open the editor form for that section.
            </p>
          </m.div>
        )}
      </AnimatePresence>
      <m.button
        onClick={toggleEditMode}
        className={cn(
          "border-foreground flex h-14 w-14 items-center justify-center border-2 shadow-[4px_4px_0px_0px_var(--foreground)] transition-all",
          isEditing
            ? "bg-foreground text-background hover:translate-x-[4px] hover:translate-y-[4px] hover:shadow-none"
            : "bg-background text-foreground hover:translate-x-[4px] hover:translate-y-[4px] hover:shadow-none"
        )}
        whileTap={{ scale: 0.95 }}
        aria-label={isEditing ? "Exit edit mode" : "Enter edit mode"}
      >
        {isEditing ? <X size={22} strokeWidth={2.5} /> : <Pencil size={22} strokeWidth={2.5} />}
      </m.button>
    </div>
  );
}
